import { useTranslation } from 'react-i18next'
import { format } from 'date-fns'
import { Box, Button, Typography } from '@mui/material'

import { dateTimeTableFormat } from '@/constants/date'
import { SportsROLibraryColumnProps } from '@/state/sports-ro-calculator/models'
import {
  useSportsROCalculatorActions,
  useSportsROCalculator,
} from '@/views/sports-ro-calculator/hooks'

import { TableGenericComponent } from '@/views/components'
import { SportsROTableRow } from './'

export const SportsROCalculatorTableComponent = () => {
  const { t } = useTranslation()

  const {
    isLoading,
    sortedRows,
    createSortHandler,
    order,
    orderBy,
    headCells,
    getXlsFormattedRow,
    filters,
    sportsRO,
  } = useSportsROCalculator()

  const { getAllSportsROCalculator } = useSportsROCalculatorActions()

  const body = sortedRows?.map((row: SportsROLibraryColumnProps) => {
    return <SportsROTableRow key={row.id} row={row} />
  })

  const fileName = `sports-rollover-calculator-${format(
    new Date(),
    dateTimeTableFormat,
  )}`

  const xlsxButton = (
    <Button
      onClick={() =>
        getAllSportsROCalculator(
          {
            ...filters,
            xlsx: true,
          },
          headCells,
          fileName,
          getXlsFormattedRow,
        )
      }
      variant="contained"
    >
      {t('labels.downloadAsXLS')}
    </Button>
  )

  return (
    <>
      {sortedRows.length > 0 && (
        <Box display="flex" justifyContent="right" gap={2} mb={3}>
          <Typography component="span" fontWeight={700} fontSize={18}>{`${t(
            'wallet.totalRolloverAmount',
          )}:`}</Typography>
          <Typography component="span" fontSize={18}>
            {sportsRO?.rolloverAmount}
          </Typography>
        </Box>
      )}
      <TableGenericComponent<SportsROLibraryColumnProps>
        order={order}
        orderBy={orderBy}
        headCells={headCells}
        rowLength={sortedRows.length}
        isLoading={isLoading}
        body={body}
        hasAction={true}
        leftContent={xlsxButton}
        createSortHandler={createSortHandler}
      />
    </>
  )
}
